var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'check',
    { 'check--right-sided': _vm.rightSided },
    { 'check--round': _vm.round }
  ]},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.changeHandler}}),_c('span',{staticClass:"check__checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }